import React, { Component } from "react";
import { Card, Col, Row, Button } from "react-bootstrap";
//import "./RGIPoliciesThankspage.css";
// import jsPDF from "jspdf";
import { toast } from "react-toastify";
import configData from "../config.json";
import "./ZunoPolicydownload.css";
export default class ZunoPolicydownload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chpiId: sessionStorage.getItem("chpiId"),
      proposalId: sessionStorage.getItem("proposalId"),
      proposalNum: sessionStorage.getItem("proposalNum"),
      baseproductId: sessionStorage.getItem("baseproductId"),
      cqrId: sessionStorage.getItem("cqrId"),
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      zuno_totalAmount: sessionStorage.getItem("totalAmount"),
      policyuuid: sessionStorage.getItem("policyId"),
      policyStatus: false,
      downloader: false,
      pdfData: "",
      premium: [],
      download: {},
      dateValues: {},
      responseData: null,
    };
  }
  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };

  componentDidMount() {
    this.handleSubmitClick();
  }
  handleSubmitClick = (e) => {
    var formData = new FormData();
    const jsonData = {
      sourceId: "6128058a-3ff6-4e38-b712-9ed1b8d1d52e",
    };
    const jsonData1 = JSON.stringify(jsonData);
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 389);
    formData.append("savedata", "yes");
    formData.append("jsonData", JSON.stringify(jsonData1));
    fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          sessionStorage.setItem("planrequestId", data.requestId);
          setTimeout(() => {
            this.ResponsejsonfetchHandler();
          }, 10000);
        }
      });
  };
  ResponsejsonfetchHandler = () => {
    const sessionRequestId = sessionStorage.getItem("planrequestId");
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 389);
    formData.append("requestId", sessionRequestId);
    fetch(
      configData.api_url + "C_Integrationlibrary/retriveResJsonByRequestId",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          // Store the quotes data
          this.setState({ responseData: data.data.data });
        } else {
          this.showToast("No policy data found", "warning");
        }
      })
      .catch((err) => {
        console.error("Failed to fetch response JSON:", err);
        this.showToast("Unable to load premium details", "error");
      });
  };
  handleDownload = (url) => {
    window.open(url, "_blank");
  };
  // apisfetchHandler = () => {
  //   var formData = new FormData();
  //   formData.append("proposalId", this.state.proposalId);
  //   fetch(configData.api_url + "zuno_Leads/getleaddetails/", {
  //     method: "POST",
  //     mode: "cors",
  //     body: formData,
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       this.showToast(data.message, data.success);
  //       if (data.status === "success") {
  //         this.setState({ premium: data.lead.premium });
  //         this.getproposalStatus();
  //       }
  //     });
  // };
  // getproposalStatus = () => {
  //   var formData = new FormData();
  //   formData.append("proposalId", this.state.proposalId);
  //   formData.append("chpiId", this.state.chpiId);
  //   fetch(configData.api_url + "zuno_Leads/getproposalStatus/", {
  //     method: "POST",
  //     mode: "cors",
  //     body: formData,
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       // this.showToast(data.message, data.success);
  //       if (data.status === "success") {
  //         if (data.policy.policyStatus === "2") {
  //           var formData = new FormData();
  //           formData.append("proposalId", this.state.proposalId);
  //           formData.append("CorrelationID", data.correlationId);
  //           formData.append("policyNum", data.policy.policyNum);
  //           formData.append("pId", data.policy.pId);
  //           formData.append("proposalNum", data.policy.proposalNum);
  //           formData.append("customerID", this.state.premium.customerID);
  //           fetch(configData.api_url + "zuno_Leads/generateproposalpdf/", {
  //             method: "POST",
  //             mode: "cors",
  //             body: formData,
  //           })
  //             .then((response) => response.json())
  //             .then((data) => {
  //               this.showToast(data.message, data.success);
  //               if (data.status === "success") {
  //                 if (data.policy !== "") {
  //                   this.setState({ downloader: true });
  //                 }
  //               }
  //             });
  //           //this.setState({ downloader: true });
  //         }
  //       }
  //     });
  // };
  // handleDownload = () => {
  //   var formData = new FormData();
  //   formData.append("proposalId", this.state.proposalId);
  //   fetch(configData.api_url + "zuno_Leads/getproposalpdf/", {
  //     method: "POST",
  //     mode: "cors",
  //     body: formData,
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       this.showToast(data.message, data.success);
  //       if (data.status === "success") {
  //         // this.setState({ pdfData: data.policy.policyPdf });
  //         if (data.policy.policyPdf !== "") {
  //           this.downloadPdf(data.policy.policyPdf);
  //         }
  //       }
  //     });
  // };
  // downloadPdf = (policyPdf) => {
  //   console.log(this.state.pdfData);
  //   const pdfUrl = configData.api_url + policyPdf;
  //   console.log(pdfUrl);
  //   const link = document.createElement("a");
  //   link.href = pdfUrl;
  //   link.download = this.state.premium.policyNumber + ".pdf"; // specify the filename
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };
  render() {
    const { responseData } = this.state;
    return (
      <div className="zuno-container">
        <h3 className="logoskybluecolor mb-4">Zuno Policy Download</h3>

        {responseData ? (
          <Row className="justify-content-center">
            <Col md={8}>
              <Card className="policy-card shadow-lg border-0 rounded-3">
                <Card.Body className="p-5 text-center">
                  <h4 className="policy-title">
                    ✅ Policy Issued Successfully
                  </h4>
                  <p className="policy-detail">
                    <strong>Status:</strong> {responseData.policyStatus}
                  </p>
                  <p className="policy-detail">
                    <strong>Proposal ID:</strong> {responseData.proposalId}
                  </p>

                  <div className="d-flex justify-content-center gap-4 mt-4">
                    <Button
                      className="download-btn proposal-btn"
                      onClick={() =>
                        this.handleDownload(responseData.eProposal)
                      }
                    >
                      📄 Download e-Proposal
                    </Button>
                    <Button
                      className="download-btn kit-btn"
                      onClick={() =>
                        this.handleDownload(responseData.policyKit)
                      }
                    >
                      📑 Download Policy Kit
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        ) : (
          <Row className="justify-content-center mt-4">
            <Col md={6}>
              <Card className="shadow-sm border-0 rounded-3">
                <Card.Body className="p-4 text-center text-muted">
                  Fetching your policy details, please wait...
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}
